<template>
  <div>
    <div v-if="label" class="label grey--text mt-3" :class="classes.label">
      {{ label }}
    </div>
    <div
      class="material-input"
      @click="focusInput"
    >
      <span class="prefix">{{ prefix }}</span>
      <input
        class="expanding-input"
        type="text"
        ref="input"
        placeholder="$0"
        :value="value"
        @focus="focusFunction($refs.input)"
        @input="updateValue($event.target.value)"
        @blur="emitBlur"
      />
      <span class="bar"></span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'expanding-input',
    props: {
      value: {
        type: String,
        default: ''
      },
      prefix: {
        type: String,
        default: ''
      },
      autofocus: {
        type: Boolean,
        default: false,
      },
      label: String,
    },
    data () {
      return {
        focused: false,
      }
    },
    computed: {
      classes () {
        return {
          label: {
            active: this.focused
          }
        }
      },
    },
    methods: {
      emitBlur () {
        this.$emit('blur')
        this.focused = false
      },
      focusFunction (el) {
        this.$emit('focus')
        this.resize(el)
      },
      focusInput () {
        this.$refs.input.focus()
        this.focused = true
      },
      resize (el) {
        // Get the element's current font size so its width can be
        // resized accordingly
        const fontSize = parseFloat(
          window.getComputedStyle(el, null).getPropertyValue('font-size')
        )
        el.style.width = ((el.value.length + 1) * fontSize * 0.55 + 10) + 'px'
      },
      updateValue (value) {
        // Need this to prevent addition of '-'
        let newVal = value
        if (value.indexOf('-') >= 0) {
          newVal = value.replace('-', '')
        }
        this.$emit('input', newVal)
        // Need this or '-' will still show for one tick
        this.$forceUpdate()
      }
    },
    mounted () {
      this.resize(this.$refs.input)
      this.$nextTick(() => {
        if (this.autofocus) {
          this.focusInput()
        }
      })
    },
    beforeUpdate () {
      this.resize(this.$refs.input)
    }
  }
</script>

<style lang="scss" scoped>
  @import '~Styles/_base';

  .material-input {
    border-bottom: 1px solid #F6F6F6;

    .bar {
      margin-bottom: -3px;
      position: relative;
      display: block;
      width: 100%;
    }

    .bar:before, .bar:after {
      content: '';
      height: 2px;
      width: 0;
      bottom: 1px;
      position: absolute;
      background: $primaryColor;
      transition: 0.2s ease all;
      -moz-transition: 0.2s ease all;
      -webkit-transition: 0.2s ease all;
    }

    .bar:before {
      left: 50%;
    }

    .bar:after {
      right: 50%;
    }

    /* active state */
    input:focus ~ .bar:before, input:focus ~ .bar:after {
      width: 50%;
    }
  }

  .prefix {
    margin-right: -15px;
  }

  .expanding-input {
    min-width:50px!important;
    width: 50px;
    max-width:99.99%!important;
    transition: width 0.01s;
    text-align:center;

    &:focus {
      outline: none;
    }
  }

  .label {
    font-size: 18px;
  }

  .label.active {
    color: $primaryColor!important;
  }
</style>
